import React, { useCallback, useEffect, useMemo } from 'react'

import { useEventHandler, useInstData } from 'tyan/public/hooks'
import ClearButton from './ClearButton'
import ShowPassword from './ShowPassword'
import IconButton from './IconButton'
/**
 * props:{
 *  value 
 *  required
 *  name = 'input'
 *  type = 'text'		// 'text', 'password'
 *  placeholder
 *  buttons = [{icon, handler, disabled, hidden}, ...]
 * }
 * @param {*} props 
 */
const Input = props => {
	const {
		onChange, field: { onEnterKey } = {}, value: valueProp, required, clearable, name = 'input', placeholder, buttons = [], disabled, tooltip,
		type: typeProp = 'text', editable, maxRows, noLocale, passwordShowable = true, passwordSavable = false, fontSize,
		changeParam, _validStamp
	} = props

	const {
		me, setState, me: { state: {
			showPassword, value, focused, edited
		} }
	} = useInstData(props, useCallback(() => ({
		nullData: '', valueProp,
		state: { showPassword: false, value: valueProp, focused: false }
	}), []))

	me.valueProp != valueProp && (me.valueProp = valueProp, valueProp != value && (valueProp || value) && setState({ value: valueProp }))

	const type = typeProp == 'password' && (!passwordSavable || showPassword) ? 'text' : typeProp

	const doChange = useCallback(value => {
		setState({ value, edited: true })
		onChange && onChange(value, changeParam)
	}, [])

	const handleChange = useCallback(event => {
		doChange(event.target.value)
	}, [])

	const handleClear = useCallback(() => {
		doChange(me.nullData)
	}, [])

	const handleInputFocus = useCallback(() => {
		setState({ focused: true })
	}, [])

	const handleInputBlur = useCallback(() => {
		setState({ focused: false, showPassword: false })
	}, [])

	const handleButtonFocus = useCallback(() => {
		me.input.focus();
	}, [])

	const handleTogglePassword = useCallback(() => {
		setState(state => ({ showPassword: !state.showPassword }))
	}, [])

	const handleKeyPress = useEventHandler(event => {
		const { charCode, altKey, ctrlKey, shiftKey, target: input } = event
		onEnterKey && charCode === 13 && (input.select(), onEnterKey({ value, altKey, ctrlKey, shiftKey, input }))
	})
	// useEffect(() => {
	// 	// value != valueProp && (console.log('effect setState'), setState({ value: valueProp }))
	// }, [valueProp])

	// useEffect(() => {
	// 	// true && (value || valueProp) && value != valueProp && onChange && (console.log('effect onChange'), onChange(value))
	// }, [value])

	const groupClass = `e-input-group t-input-group${disabled ? ' e-disabled' : ''}${focused ? ' e-input-focus' : ''}`
		+ `${required && !value && (edited || _validStamp) ? ' e-valid-input e-error' : ''}`
	const inputClass = `e-input${typeProp == 'password' && !showPassword ? ' t-input-password' : ''}`
	// console.log('Input render:', value)
	// typeProp == 'password' && console.log('inputclass:', inputClass)
	return <div className={groupClass} style={{ fontSize }}>
		<input className={inputClass} autoComplete='off' ref={ref => me.input = ref}
			{...{ value: value || me.nullData, required, name, type, placeholder, disabled }}
			{...(tooltip ? { 'data-qtip': tooltip, 'data-qanchor': true } : {})}
			{...(onEnterKey ? { onKeyPress: handleKeyPress } : {})}
			onFocus={handleInputFocus} onBlur={handleInputBlur} onChange={handleChange} />
		{clearable && <ClearButton {...{ focused, value, onClear: handleClear }} /> || null}
		{typeProp === 'password' && passwordShowable
			&& <ShowPassword {...{ focused, value, showPassword, onTogglePassword: handleTogglePassword }} />
			|| null}
		{buttons.map((button, index) => <IconButton key={index} {...{ button, disabled, value, onFocus: handleButtonFocus }} />)}
	</div>
}

export default Input